var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticClass: "export-test-paper" },
    [
      _c("el-header", [_c("h2", [_vm._v("导出试卷")])]),
      _c(
        "el-container",
        [
          _c(
            "el-aside",
            { attrs: { width: "156px" } },
            [
              _c("h3", [_vm._v("试卷结构调整")]),
              _c(
                "el-checkbox-group",
                {
                  model: {
                    value: _vm.checkList,
                    callback: function ($$v) {
                      _vm.checkList = $$v
                    },
                    expression: "checkList",
                  },
                },
                [
                  _c("el-checkbox", { attrs: { label: "A" } }),
                  _c("el-checkbox", { attrs: { label: "B" } }),
                  _c("el-checkbox", { attrs: { label: "大题评分区" } }),
                  _c("el-checkbox", { attrs: { label: "禁用" } }),
                  _c("el-checkbox", { attrs: { label: "选中" } }),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-main", [_vm._v("Main")]),
        ],
        1
      ),
      _c(
        "el-footer",
        [
          _c("DsfButton", [_vm._v("保存")]),
          _c("DsfButton", [_vm._v("取消")]),
          _c("DsfButton", [_vm._v("导出试卷")]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }